import { useAuthStore } from '@/auth/useAuthStore'
import { logError } from '@/logger'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const getFeatureFlagUserId = (): string | null | undefined => {
  const authStore = useAuthStore()

  return authStore.user?.email ?? authStore.user?.id
}

export const refreshFeatureFlagsForBrand = async (
  brandId: string | undefined
): Promise<void> => {
  if (!brandId) {
    return
  }

  const featureFlags = useFeatureFlags()
  const context = featureFlags.getContext()
  const userId = getFeatureFlagUserId()
  const resolvedUserId = userId ?? context.userId

  if (
    context.properties?.brandId === brandId &&
    context.userId === resolvedUserId &&
    featureFlags.isReady()
  ) {
    return
  }

  try {
    await featureFlags.updateContext({
      currentTime: context.currentTime,
      properties: {
        ...context.properties,
        brandId,
      },
      remoteAddress: context.remoteAddress,
      sessionId: context.sessionId,
      userId: resolvedUserId,
    })
  } catch (error) {
    logError(error, {
      brandId,
      context: 'refreshFeatureFlagsForBrand',
    })
  }
}
